import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Cloud2: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m408.46 483.73-63.14-76.09-63.13 76.09-23.09-19.15 86.22-103.92 86.22 103.92z' />
    <path d='m330 393.87h30v130.29h-30z' />
    <path d='m270 539.15c-46.55 0-85.41-14.28-112.38-41.31-24.92-24.97-38.65-60.38-38.65-99.69 0-33.26 11.59-67.25 31.8-93.25 22.93-29.5 54.62-45.75 89.23-45.75v30c-32.23 0-53.44 18.58-65.55 34.16-15.96 20.53-25.48 48.51-25.48 74.84 0 31.77 10.33 58.91 29.88 78.5 21.22 21.26 52.74 32.5 91.15 32.5z' />
    <path d='m605.82 478.32-21.63-20.78c29.55-30.76 45.82-71.02 45.82-113.39 0-90.98-75.15-165-167.51-165-45.55 0-86.61 16.97-115.62 47.78-30.66 32.57-46.87 78.29-46.87 132.22-16.98 0-30.16-14.79-28.25-31.66 5.46-48.16 23.6-89.6 53.27-121.12 34.74-36.9 83.56-57.22 137.47-57.22 108.91 0 197.51 87.48 197.51 195 0 50.15-19.24 97.8-54.18 134.17z' />
    <path d='m494.68 627.64-86.22-103.91 23.08-19.15 63.14 76.08 63.13-76.08 23.09 19.15z' />
    <path d='m480 479.15h30v115.29h-30z' />
    <path d='m510 359.15v120s-30 0-30 0v-90c0-16.57 13.43-30 30-30z' />
    <path d='m360 629.15v-120s-30 0-30 0v90c0 16.57 13.43 30 30 30z' />
  </IconBase>
));

Cloud2.displayName = 'Cloud2';

export default Cloud2;
